<template>
  <div :class="containerClassObject">
    <div v-if="label" :id="`${id}-label`" class="wm-field-label">
      <label :for="id" :class="{required: required}">{{ label }}</label>
    </div>
    <div class="wm-field-input">
      <input
        :id="id"
        :type="type"
        :name="name"
        :value="value"
        :class="{ error: $v.$error }"
        :placeholder="placeholder"
        :maxlength="maxlength"
        @focus="onFocus"
        @blur="onBlur"
        @keyup="onKeyup"
      >
    </div>
    <validation-message-list
      :$v="$v"
      :property-path="name"
      translation-name-space="companyForm"
    />
  </div>
</template>

<script>
import InputField from './InputField'

/* @flow */
export default {
  name: 'InitialsInputField',
  extends: InputField,
  methods: {
    onKeyup (event) {
      if (event.keyCode !== 8 && event.keyCode !== 46 && !(event.keyCode > 36 && event.keyCode < 41)) {
        this.onInput(event)
      } else if (event.target.value && event.target.value.slice(-1) !== '.') {
        event.target.value = event.target.value.slice(0, -1)
        this.onInput(event)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/fields/InitialsInputField.vue